import { createReducer } from '../utils/helpers';
import constants from '../constants';
import { getEnumLong } from '../utils/helpers';

const { FETCH_NATIONS_REQUEST, FETCH_NATIONS_SUCCESS, FETCH_NATIONS_FAILURE } = constants;

const initialState = {
  nations: [],
  isFetchingData: false,
};

export default createReducer(initialState, {
  [FETCH_NATIONS_REQUEST]: state => ({
    ...state,
    ...{
      nations: [],
      isFetchingData: true,
    },
  }),
  [FETCH_NATIONS_SUCCESS]: (state, payload) => {
    const { nations } = payload;

    const nationsFull = nations.map(n => ({
      name: getEnumLong('nations', n),
      value: n,
    }));

    return {
      ...state,
      ...{
        nations: nationsFull,
        isFetchingData: false,
      },
    };
  },
  [FETCH_NATIONS_FAILURE]: state => ({
    ...state,
    ...{
      nations: [],
      isFetchingData: false,
    },
  }),
});



// WEBPACK FOOTER //
// ./src/reducers/nations.js